import styled from 'styled-components';

import {
  Title as ProductCardTitle,
  DescriptionDiv as ProductCardDescriptionDiv,
} from '../ProductCard/ProductCard.style';

export const Container = styled.div`
  display: flex;
  font-family: Montserrat;
  flex-direction: column;
  padding: 2.4rem;
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cLightGrey};
  border-radius: 0.2rem;
`;

export const MainContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};

  &:before {
    content: '';
    border: 1px dashed ${({ theme: { colors } }) => colors.b2cLightGrey};
    align-self: stretch;
  }

  gap: 2rem;
  justify-content: space-around;
`;

export const ContentContainer = styled.div<{ showSeperator?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
  ${({ showSeperator }) => showSeperator && 'order: -1;'};
`;

export const PriceContainer = styled(ContentContainer)<{ isMobile: boolean }>`
  min-width: 15rem;
  flex: 0;
  align-items: center;
  justify-content: ${({ isMobile }) => (isMobile ? 'space-between' : 'center')};
  ${({ isMobile }) => isMobile && 'flex-direction: row;'};
  ${({ isMobile }) => !isMobile && 'text-align: center;'};
`;

export const Title = styled(ProductCardTitle)``;
export const DescriptionDiv = styled(ProductCardDescriptionDiv)``;

export const DiscountDisclaimer = styled.span`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  width: max-content;
  height: 2.6rem;
  background: ${({ theme: { colors } }) => colors.b2cRedThl};
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cRedThl};
  border-radius: 0.2rem;
  color: ${({ theme: { colors } }) => colors.b2cWhite};
  text-align: center;
  font-size: 1.28rem;
`;
